/* eslint-disable @typescript-eslint/naming-convention */
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Router from "src/routers/RouterPrincipal";
import "./App.css";
import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material/styles";
import { EuiProvider } from "@elastic/eui";
import { GRIS_100, GRIS_50, PRIMARIO, SECUNDARIO } from "./styles/styles";

function App() {
  return (
    <div className="App">
      <ThemeProvider
        theme={createTheme({
          palette: {
            primary: {
              main: '#002552',
            },
            secondary: {
              main: SECUNDARIO,
            },
            grey: {
              50: GRIS_50,
              100: GRIS_100,
            },
          },
        })}
      >
        <EuiProvider
          colorMode="light"
          modify={{
            colors: {
              LIGHT: {
                primary: PRIMARIO,
              },
              DARK: {
                primary: "#e378e4",
              },
            },
          }}
        >
          <ToastContainer />
          <Router />
        </EuiProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
